<template>
  <div>
    <a-upload
      :accept="accept"
      name="file"
      :action="uploadData.upload_url"
      :data="uploadData"
      list-type="picture-card"
      :file-list="fileList"
      class="avatar-uploader"
      :multiple="multiple"
      :before-upload="handleBeforeUpload"
      @change="handleChange"
      @preview="handlePreview"
    >
      <div v-if="fileList.length < maxCount">
        <p class="ant-upload-plus-icon">
          <a-icon type="plus" />
        </p>
        <p class="ant-upload-text">
          点击上传
        </p>
      </div>
    </a-upload>

    <preview-image
      :visible.sync="previewVisible"
      :image.sync="previewImage"
    />
  </div>
</template>

<script>
import { getResourceURL, getUploadToken, getUploadWatermarkToken } from '@/api/upload'
import PreviewImage from '@/components/PreviewImage'

export default {
  name: 'UploadImage',
  components: { PreviewImage },
  props: {
    // 已经上传的图片
    defaultFileList: {
      type: Array,
      default() {
        return []
      }
    },
    // 最多上传图片数量
    maxCount: {
      type: Number,
      default: 1
    },
    // 图片大小最大值(字节)
    maxSize: {
      type: Number,
      default: 10 * 1024 * 1024
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    acceptValidateFunc: {
      type: Function,
      default: function() {
        return true
      }
    },
    isAddWatermark: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    // 存储方式 local（本地）/cos（腾讯云)
    storageMethod: {
      type: String,
      default: 'local'
    }
  },
  data() {
    return {
      fileList: this.defaultFileList,
      uploadData: {},
      previewVisible: false,
      previewImage: ''
    }
  },
  created() {
    this.getUploadToken()
  },
  watch: {
    defaultFileList(val) {
      this.fileList = val
    }
  },
  methods: {
    getUploadToken() {
      if (this.isAddWatermark) {
        getUploadWatermarkToken().then(res => {
          this.uploadData = res.data
          this.uploadData.storage_method_slug = this.storageMethod
        })
      } else {
        getUploadToken().then(res => {
          this.uploadData = res.data
          this.uploadData.storage_method_slug = this.storageMethod
        })
      }
    },

    triggerChange() {
      // Should provide an event to pass value to Form.
      this.$emit('change', this.fileList)
    },

    handleChange(info) {
      // 限制上传个数
      this.fileList = info.fileList.slice(-this.maxCount)
      this.triggerChange()
    },

    handleBeforeUpload(file, fileList) {
      if (file.size > this.maxSize) {
        this.$message.error(`图片大小不能超过 ${this.maxSize / 1024.0 / 1024.0} MB`)
        file.status = 'error'
        return false
      }

      // 文件类型是否合法
      if (!this.acceptValidateFunc(file)) {
        this.$message.error('图片格式不正确')
        file.status = 'error'
        return false
      }
    },

    // 显示图片预览
    handlePreview(file) {
      getResourceURL(file.response).then((res) => {
        if (res.code === 0) {
          this.previewImage = res.data.resource_url
          this.previewVisible = true
        }
      })
    }
  }
}
</script>
